import {
  EffectFade, Navigation, Swiper, Controller,
} from 'swiper';

class SwiperAndCopy {
  constructor(element) {
    if (!(element instanceof HTMLElement)) {
      throw new TypeError('Invalid element');
    }
    this.mediaSwiperElement = element.querySelector('.swiper-copy');
    this.textSwiperElement = element.querySelector('.text-swiper');
    this.element = element;

    this.initSwiper();
  }

  initSwiper() {
    this.size = this.mediaSwiperElement.dataset.size ?? 'large';
    this.direction = this.mediaSwiperElement.dataset.direction ?? 'right';

    if (this.textSwiperElement) {
      this.textSwiper = new Swiper(this.textSwiperElement, {
        modules: [EffectFade, Controller],
        slidesPerView: 1,
        effect: 'fade',
        fadeEffect: {
          crossFade: true,
        },
        allowTouchMove: false,
      });
    }
    this.swiper = new Swiper(this.mediaSwiperElement, {
      modules: [Navigation, Controller],
      slidesPerView: 'auto',
      slidesPerGroup: 1,
      loop: false,
      centeredSlides: false,
      spaceBetween: 20,
      speed: 500,
      navigation: {
        prevEl: '.swiper-button-prev',
        nextEl: '.swiper-button-next',
      },
      on: {
        snapGridLengthChange() {
          if (this.snapGrid.length !== this.slidesGrid.length) {
            this.snapGrid = this.slidesGrid.slice(0);
          }
        },
      },
    });

    if (this.textSwiper) {
      this.swiper.controller.control = this.textSwiper;
      this.textSwiper.controller.control = this.swiper;
    }

    if (this.direction === 'left') {
      this.swiper.slideTo(this.swiper.slides.length - 1);
      if (this.textSwiper) {
        this.textSwiper.slideTo(this.textSwiper.slides.length - 1);
      }
    }

    // this.swiper.on('slideChangeTransitionStart', (swiper) => {
    // swiper.slides.forEach((slide) => {
    //   slide.classList.remove('swiper-slide-large');
    // });
    // // prior to the slide changing, resize the next slide to 400x400px and recalculate swiper size
    // const nextSlide = swiper.slides[swiper.activeIndex];
    // nextSlide.classList.add('swiper-slide-large');
    // swiper.updateSize();
    // });
  }

  /**
   *
   * @param Swiper swiper swiper
   */
  updateSlideClasses(swiper) {
    // keep getting sibling until there are none left.

    /**
     * @var Element slide
     */
    const marginMultiplier = this.size === 'large' ? 12 : 5.4;
    const slide = swiper.slides[swiper.activeIndex];
    slide.style.transform = null;
    let nextSlide = slide.nextElementSibling;

    // clear any potential transform from the previous elements
    let prevSlide = slide.previousElementSibling;
    let prevIdx = 0;
    while (prevSlide) {
      const translateAmount = prevIdx * marginMultiplier;
      prevSlide.style.transform = `translateX(${translateAmount}rem)`;
      prevSlide = prevSlide.previousElementSibling;
      prevIdx += 1;
    }

    let nextIdx = 0;
    while (nextSlide) {
      const translateAmount = nextIdx * -marginMultiplier;
      nextSlide.style.transform = `translateX(${translateAmount}rem)`;
      nextSlide = nextSlide.nextElementSibling;
      nextIdx += 1;
    }

    // swiper.update();
  }
}

export default SwiperAndCopy;
